import React from 'react';
import { Facebook, Mail, Phone } from 'lucide-react';
import { Logo } from './Logo';
import { business, nav, services } from '../data/site';
export function Footer() {
  return <footer className="bg-black" data-id="element-66" data-mp="32nun0sijob3h">
      <div className="hatch h-1.5 w-full" aria-hidden="true" data-id="element-67" data-mp="32ovxaurqktk5" />
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-16 lg:grid-cols-[1.2fr_1fr_1fr] lg:px-10 lg:py-20" data-id="element-68" data-mp="36pfufycb7x6a">
        <div data-id="element-69" data-mp="3ueim7z0nr6ei">
          <Logo className="h-28 w-auto" invert data-id="element-70" data-mp="3ug3e1gvl8b8o" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-steel-400" data-id="element-71" data-mp="3ud7h9vvh7slt">
            {business.tagline} — fencing, entryways, gates, carports, and mobile welding out of{' '}
            {business.base}. Owned and operated by {business.owner}.
          </p>
          <div className="mt-7 flex flex-wrap gap-3" data-id="element-72" data-mp="3qc3yp1m1nigw">
            <a href={business.phoneHref} className="inline-flex items-center gap-2 border border-white/15 px-4 py-3 font-mono text-xs text-white transition-colors hover:border-brand hover:text-brand-light" data-id="element-73" data-mp="29zglw3w5synp">
              <Phone className="h-3.5 w-3.5" aria-hidden="true" data-id="element-74" data-mp="3la29svmrl5vr" />
              {business.phone}
            </a>
            <a href={`mailto:${business.email}`} className="inline-flex items-center gap-2 border border-white/15 px-4 py-3 font-mono text-xs text-white transition-colors hover:border-brand hover:text-brand-light" data-id="element-75" data-mp="3gca5f24xnrao">
              <Mail className="h-3.5 w-3.5" aria-hidden="true" data-id="element-76" data-mp="828oa9xiabb9" />
              Email
            </a>
            <a href={business.facebookHref} className="inline-flex items-center gap-2 border border-white/15 px-4 py-3 font-mono text-xs text-white transition-colors hover:border-brand hover:text-brand-light" data-id="element-77" data-mp="34p8h5l5tqh7">
              <Facebook className="h-3.5 w-3.5" aria-hidden="true" data-id="element-78" data-mp="cvtmo330h7az" />
              Facebook
            </a>
          </div>
        </div>

        <nav aria-label="Footer" data-id="element-79" data-mp="msg6qpnijuby">
          <h2 className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand-light" data-id="element-80" data-mp="mthk50s04swu">Site</h2>
          <ul className="mt-6 space-y-3" data-id="element-81" data-mp="two2jpj5v957">
            {nav.map(item => <li key={item.href} data-id="element-82" data-mp="yv953vlvy4wt">
                <a href={item.href} className="font-display text-sm uppercase tracking-[0.12em] text-steel-300 transition-colors hover:text-white" data-id="element-83" data-mp="yuhb2p7xsf8n">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-84" data-mp="1cnyqbxtlb5sv">
          <h2 className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand-light" data-id="element-85" data-mp="1hkp94sws4fhz">
            Services
          </h2>
          <ul className="mt-6 space-y-3" data-id="element-86" data-mp="1mjihk6x7lgba">
            {services.map(service => <li key={service.title} data-id="element-87" data-mp="1rjep2g547pvl">
                <a href="#services" className="font-display text-sm uppercase tracking-[0.12em] text-steel-300 transition-colors hover:text-white" data-id="element-88" data-mp="1rid3hhqh3kzm">
                  {service.title}
                </a>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-89" data-mp="2agyfna1uv5qc">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-5 py-6 font-mono text-[10px] uppercase tracking-[0.18em] text-steel-500 sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-90" data-mp="25nca01u40241">
          <span data-id="element-91" data-mp="1worxjif56oo9">
            © {new Date().getFullYear()} {business.name}
          </span>
          <span data-id="element-92" data-mp="2te99ug8mr8yx">Licensed &amp; Insured · {business.base}</span>
        </div>
      </div>
    </footer>;
}